module.exports = __webpack_public_path__ + "files/6da420ab9e0789907c9eb0491a97cd03.png";